import { useLazyQuery } from '@apollo/client';
import { ToastType } from '@alefeducation/ui-elements-library-core';
import { useState } from 'react';
import { ADD_ADMIN_TOAST_ID } from './useAddAdminUserAPI';
import { AdminRole } from './useAddAdminUser';
import {
  GET_ADMIN_BY_EMAIL,
  GetAdminByEmailResponse,
} from '../../../apollo/queries/adminUsers/adminUserByEmail.queries';
import { injectAutoHideToastOfType } from '../../../utils/Toast';
import {
  ADMIN_WITH_DIFF_ROLE_EXIST_MESSAGE,
  SOMETHING_WENT_WRONG_MESSAGE,
} from '../../../utils/constants';

type Props = {
  onComplete: (userId: string | null, isEmailExist: boolean) => void;
};

const useAdminByEmailAPI = ({ onComplete }: Props) => {
  const [message, setMessage] = useState('');

  const [getAdminByEmail, { loading }] = useLazyQuery<GetAdminByEmailResponse>(
    GET_ADMIN_BY_EMAIL,
    {
      onCompleted: (data) => {
        if (data) {
          if (data.adminUserByEmail) {
            const { roles, id } = data.adminUserByEmail;

            const isSuperAdmin =
              roles && roles.includes(AdminRole.SUPER_ADMIN_ORG);

            setMessage(isSuperAdmin ? '' : ADMIN_WITH_DIFF_ROLE_EXIST_MESSAGE);
            onComplete(isSuperAdmin ? id : null, isSuperAdmin);
          } else {
            setMessage('');
            onComplete(null, false);
          }
        }
      },
      onError: (e: any) => {
        const errorData =
          e.graphQLErrors && e.graphQLErrors[0] && e.graphQLErrors[0].data;
        const isEmailNotExist = errorData && errorData.errorCode === 1002;

        if (message !== '') {
          setMessage('');
        }

        if (isEmailNotExist) {
          onComplete(null, false);
        } else {
          injectAutoHideToastOfType(
            ADD_ADMIN_TOAST_ID,
            SOMETHING_WENT_WRONG_MESSAGE,
            ToastType.ERROR,
          );
        }
      },
      fetchPolicy: 'cache-and-network',
    },
  );

  const adminByEmail = (email: string) => {
    getAdminByEmail({
      variables: {
        email,
      },
    });
  };

  return {
    adminByEmail,
    loading,
    message,
  };
};

export default useAdminByEmailAPI;
